import { isEmpty } from 'lodash';

import constants from './constants.json';

const { ERRORS } = constants;
const BASE_KEY = 'components.validation_issues';

export default function loginValidationErrors(props) {
    const {
        login: {
            showLoginFailedMessage,
            loginAttemptErrors,
        },
    } = props;

    const hasLoginAttemptErrors = !isEmpty(loginAttemptErrors);
    const { locked, accountWillLockIn } = loginAttemptErrors;

    if (hasLoginAttemptErrors && locked) {
        return {
            id: `${BASE_KEY}.${ERRORS.LOGIN_LOCKED}`,
            values: { locked },
        };
    }

    if (hasLoginAttemptErrors && accountWillLockIn) {
        return {
            id: `${BASE_KEY}.${ERRORS.LOGIN_ACCOUNT_WILL_LOCK_IN}`,
            values: { accountWillLockIn },
        };
    }

    if (showLoginFailedMessage) {
        return {
            id: `${BASE_KEY}.${ERRORS.LOGIN_INCORRECT}`,
        };
    }

    return null;
}
